import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import EvaluationDetails from "./routes/EvaluationDetails";
export default store => ({
  path: "assessmentEvaluation",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "assessment-evaluation" */ "./components"),
        import(
          /* webpackChunkName: "assessment-evaluation" */ "./routes/EvaluationDetails"
        ),
        import(
          /* webpackChunkName: "assessment-evaluation" */ "./modules/AssessmentEvaluationModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const EvaluationDetails = importedModule1.default;
        const reducer = importedModule2.default;
        injectReducer(store, {
          key: "assessmentEvaluation",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [EvaluationDetails(store)],
});
